/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Medal2: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <g clipPath='url(#clip0_20400_923)'>
      <path d='M11.025 6.049L8 0H1L5.3 8.6C6.88385 7.15538 8.89176 6.26067 11.025 6.049Z' fill='currentColor' />
      <path d='M12.9746 6.049L15.9996 0H22.9996L18.6996 8.6C17.1158 7.15538 15.1079 6.26067 12.9746 6.049Z' fill='currentColor' />
      <path
        d='M12 8C10.4178 8 8.87103 8.46919 7.55544 9.34824C6.23985 10.2273 5.21447 11.4767 4.60897 12.9385C4.00347 14.4003 3.84504 16.0089 4.15372 17.5607C4.4624 19.1126 5.22433 20.538 6.34315 21.6569C7.46197 22.7757 8.88743 23.5376 10.4393 23.8463C11.9911 24.155 13.5997 23.9965 15.0615 23.391C16.5233 22.7855 17.7727 21.7602 18.6518 20.4446C19.5308 19.129 20 17.5823 20 16C20 13.8783 19.1571 11.8434 17.6569 10.3431C16.1566 8.84285 14.1217 8 12 8ZM14.351 19.618L12 18.382L9.649 19.618L10.1 17L8.2 15.146L10.828 14.764L12 12.382L13.176 14.764L15.804 15.146L13.9 17L14.351 19.618Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_20400_923'>
        <rect width='24' height='24' fill='currentColor' />
      </clipPath>
    </defs>
  </React.Fragment>
)
